import { EcommerceAPI } from "../Client";
import { appendProcessedFile } from "../../../utils/imageUploadProcessor";

export const GetRatingandreviwsApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(`/ratingandreview/${payload || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetTenantRatingandreviwsApi = async () => {
  try {
    const response = await EcommerceAPI.get(`/ratingandreview/tenant`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteRatingAndReviewApi = async (ratingId) => {
  try {
    const response = await EcommerceAPI.delete(`/ratingandreview/${ratingId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ActivationRatingAndReviewApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/ratingandreview/change/active/status?ratingAndReviewid=${payload?.ratingAndReviewid || ""}&status=${payload?.status}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const PostRatingAndReviewApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/ratingandreview`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateRatingAndReviewApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/ratingandreview`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const RatingandreviewUploadFileApi = async (payload) => {
  try {
    console.log("files: ", payload);
    const formData = new FormData();
    const rawFiles = payload?.files ?? payload;
    const files = Array.from(rawFiles || []).flat();

    if (!files.length) {
      throw new Error("No files provided for upload.");
    }

    const isFile = (value) =>
      (typeof File !== "undefined" && value instanceof File) ||
      (typeof Blob !== "undefined" && value instanceof Blob);

    for (const file of files) {
      if (isFile(file)) {
        await appendProcessedFile(formData, "files", file);
      }
    }

    if (!formData.getAll("files").length) {
      throw new Error("Invalid file payload. Expected File/Blob objects.");
    }

    const response = await EcommerceAPI.post(`/ratingandreview/upload/file`, formData, {
      headers: {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteRatingandreviewUploadFileApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(
      `/ratingandreview/upload/file?key=${payload?.key || ""}`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
